export const withdrawRoutes = [
  {
    path: "/withdraw",
    name: "WithdrawForm",
    component: () => import("@/views/Withdraw/WithdrawForm.vue"),
    meta: { need2fa: true, showDemoVersion: true },
  },
  {
    path: "/withdraw/choose-type",
    name: "WithdrawChooseType",
    component: () => import("@/views/Withdraw/ChooseType.vue"),
    meta: {
      need2fa: true,
      showDemoVersion: true,
      // При возврате назад с этого экрана уводим на Dashboard,
      // чтобы пользователь не попадал на предыдущие шаги вывода
      back: { to: "Dashboard" },
    },
  },
  {
    path: "/withdraw/choose-coin",
    name: "WithdrawChooseCoin",
    component: () => import("@/views/Withdraw/ChooseCoin.vue"),
    meta: { need2fa: true, showDemoVersion: true },
  },
  {
    path: "/withdraw/choose-network",
    name: "WithdrawChooseNetwork",
    component: () => import("@/views/Withdraw/ChooseNetwork.vue"),
    meta: { need2fa: true, showDemoVersion: true },
  },
  {
    path: "/withdraw/address",
    name: "WithdrawAddressForm",
    component: () => import("@/views/Withdraw/AddressForm.vue"),
    meta: { need2fa: true },
  },
  {
    path: "/withdraw/success",
    name: "WithdrawSuccess",
    component: () => import("@/views/Withdraw/Success.vue"),
    meta: { transparentHeader: true },
  },
];
